import { colors } from '../../../../abstracts';
import { styled } from 'styled-components';
import { DEFAULT_BORDER_WIDTH } from '../constants';
import { dontForwardProps } from '../../../../util';
const StyledFooter = styled.div.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1pgl52i-0"
})(["border-bottom:", ";padding-bottom:1rem;text-align:", ";"], ({
  hasDivider
}) => hasDivider ? `${DEFAULT_BORDER_WIDTH} solid ${colors.neutralBrightest}` : `${DEFAULT_BORDER_WIDTH} solid transparent`, ({
  textAlign
}) => textAlign || 'left');
export { StyledFooter };